import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import Image from 'next/image';
import { StarIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';
import Title from '../title';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductReviewCard = function ProductReviewCard(_ref) {
  var reviewerRating = _ref.reviewerRating,
      reviewerReview = _ref.reviewerReview,
      reviewerName = _ref.reviewerName,
      reviewerCompany = _ref.reviewerCompany,
      reviewerProfilePic = _ref.reviewerProfilePic,
      reviewerCompanyLogo = _ref.reviewerCompanyLogo;

  var _useTranslation = useTranslation('product-description-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [/*#__PURE__*/_jsx(Title, {
          content: "".concat(reviewerRating, "/10"),
          fontWeight: "semibold",
          fontSize: "small",
          textColor: "neutral-700"
        }), /*#__PURE__*/_jsx(_StyledDiv4, {
          children: Array.from({
            length: 10
          }).map(function (_, index) {
            return /*#__PURE__*/_jsx(StarIcon, {
              className: "w-4 h-4 text-orange-500 ".concat(index < reviewerRating ? 'fill-current' : '', " ")
            }, index);
          })
        })]
      }), /*#__PURE__*/_jsx(Title, {
        content: t(reviewerReview),
        textColor: "neutral-700",
        twStyle: {
          "alignSelf": "stretch",
          "fontStyle": "italic"
        }
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv5, {
      children: [/*#__PURE__*/_jsx(_StyledDiv6, {
        children: /*#__PURE__*/_jsx(_StyledDiv7, {
          children: /*#__PURE__*/_jsxs(_StyledDiv8, {
            children: [/*#__PURE__*/_jsx(_StyledDiv9, {
              children: /*#__PURE__*/_jsx(Image, {
                fill: true,
                alt: "profile-pic",
                src: getAssetSrc(reviewerProfilePic),
                loader: customImageLoader
              })
            }), /*#__PURE__*/_jsxs(_StyledDiv10, {
              children: [/*#__PURE__*/_jsx(Title, {
                fontSize: "small",
                fontWeight: "semibold",
                textColor: "neutral-700",
                content: reviewerName
              }), /*#__PURE__*/_jsx(Title, {
                fontSize: "small",
                fontWeight: "semibold",
                textColor: "neutral-700",
                content: reviewerCompany
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(_StyledDiv11, {
        children: /*#__PURE__*/_jsx(Image, {
          fill: true,
          alt: "NA",
          src: getAssetSrc(reviewerCompanyLogo),
          className: "max-w-fit ".concat(reviewerCompany === 'Food&Company' ? 'absolute md:!left-[12px]' : ''),
          loader: customImageLoader
        })
      })]
    })]
  });
};
export default ProductReviewCard;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv",
  componentId: "sc-2wryqu-0"
})({
  "display": "inline-flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1.5rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "padding": "1.25rem",
  "--tw-shadow": "0px 4px 16px 0px rgba(0,0,26,0.15)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv2",
  componentId: "sc-2wryqu-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.75rem",
  "alignSelf": "stretch"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv3",
  componentId: "sc-2wryqu-2"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.625rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv4",
  componentId: "sc-2wryqu-3"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.125rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv5",
  componentId: "sc-2wryqu-4"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "alignSelf": "stretch"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv6",
  componentId: "sc-2wryqu-5"
})({
  "display": "inline-flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.625rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv7",
  componentId: "sc-2wryqu-6"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1.25rem"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv8",
  componentId: "sc-2wryqu-7"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1.25rem"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv9",
  componentId: "sc-2wryqu-8"
})({
  "position": "relative",
  "height": "2.5rem",
  "width": "2.5rem",
  "borderRadius": "9999px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-shadow": "0px 4px 4px 0px rgba(0,0,0,0.25)",
  "--tw-shadow-colored": "0px 4px 4px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv10",
  componentId: "sc-2wryqu-9"
})({
  "display": "inline-flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "center",
  "gap": "0.25rem"
});

var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "product-review-card___StyledDiv11",
  componentId: "sc-2wryqu-10"
})({
  "position": "relative",
  "display": "none",
  "height": "1.5rem",
  "width": "auto",
  "minWidth": "5%",
  "maxWidth": "4.5rem",
  "@media (min-width: 768px)": {
    "display": "inline-flex",
    "alignItems": "flex-end",
    "justifyContent": "flex-end"
  }
});